document.addEventListener('DOMContentLoaded', function () {
    const blockHalfTextMedia = document.querySelectorAll('.block-half-text-media');

    if (blockHalfTextMedia.length === 0) return;

    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
        gsap.registerPlugin(ScrollTrigger);
    }

    // Loop through each block-half-text-media section
    blockHalfTextMedia.forEach(function (blockHalfTextMedia) {
        const blockHalfTextMediaHeading = blockHalfTextMedia.querySelector('.block-half-text-media__heading');
        const blockHalfTextMediaContent = blockHalfTextMedia.querySelector('.block-half-text-media__content');
        const blockHalfTextMediaImage = blockHalfTextMedia.querySelector('.block-half-text-media__picture img');
        const blockHalfTextMediaVideo = blockHalfTextMedia.querySelector('.block-half-text-media__video video');
        const isReversed = blockHalfTextMedia.classList.contains('block-half-text-media--layout-reversed');
        const contentOffset = isReversed ? 60 : -60;
        const mediaOffset = isReversed ? -60 : 60;

        setupBlockHalfTextMediaFullscreen(blockHalfTextMedia);
        setupBlockHalfTextMediaAlternateReveal(blockHalfTextMedia);

        if (typeof gsap === 'undefined') return;

        // Check if the heading element exists
        if (blockHalfTextMediaHeading) {
            gsap.fromTo(blockHalfTextMediaHeading, {
                autoAlpha: 0,
                x: contentOffset,
            }, {
                autoAlpha: 1,
                x: 0,
                duration: 0.6,
                ease: 'power3.out',
                scrollTrigger: typeof ScrollTrigger !== 'undefined' ? {
                    trigger: blockHalfTextMedia,
                    start: 'top 80%',
                    once: true,
                } : null,
            });
        }

        // Check if the content element exists
        if (blockHalfTextMediaContent) {
            gsap.fromTo(blockHalfTextMediaContent, {
                autoAlpha: 0,
                x: contentOffset,
            }, {
                autoAlpha: 1,
                x: 0,
                duration: 0.6,
                ease: 'power3.out',
                scrollTrigger: typeof ScrollTrigger !== 'undefined' ? {
                    trigger: blockHalfTextMedia,
                    start: 'top 80%',
                    once: true,
                } : null,
            });
        }

        // Check if the image element exists
        if (blockHalfTextMediaImage) {
            gsap.fromTo(blockHalfTextMediaImage, {
                autoAlpha: 0,
                x: mediaOffset,
            }, {
                autoAlpha: 1,
                x: 0,
                duration: 0.6,
                ease: 'power3.out',
                scrollTrigger: typeof ScrollTrigger !== 'undefined' ? {
                    trigger: blockHalfTextMedia,
                    start: 'top 80%',
                    once: true,
                } : null,
            });
        }

        // Check if the video element exists
        if (blockHalfTextMediaVideo) {
            gsap.fromTo(blockHalfTextMediaVideo, {
                autoAlpha: 0,
                x: mediaOffset,
            }, {
                autoAlpha: 1,
                x: 0,
                duration: 0.6,
                ease: 'power3.out',
                scrollTrigger: typeof ScrollTrigger !== 'undefined' ? {
                    trigger: blockHalfTextMedia,
                    start: 'top 80%',
                    once: true,
                } : null,
            });
        }
    });
});

function setupBlockHalfTextMediaAlternateReveal(blockHalfTextMedia) {
    const blockHalfTextMediaOpenButton = blockHalfTextMedia.querySelector('[data-half-text-media-reveal-open]');
    const blockHalfTextMediaDefault = blockHalfTextMedia.querySelector('[data-half-text-media-default]');
    const blockHalfTextMediaAlternate = blockHalfTextMedia.querySelector('[data-half-text-media-alternate]');
    const blockHalfTextMediaDefaultMedia = blockHalfTextMedia.querySelector('[data-half-text-media-default-media]');
    const blockHalfTextMediaAlternateMedia = blockHalfTextMedia.querySelector('[data-half-text-media-alternate-media]');

    if (!blockHalfTextMediaOpenButton || !blockHalfTextMediaDefault || !blockHalfTextMediaAlternate) return;

    const blockHalfTextMediaReveal = function (event) {
        event.preventDefault();

        if (blockHalfTextMedia.classList.contains('block-half-text-media--alternate-revealed')) return;

        const blockHalfTextMediaDefaultVideo = blockHalfTextMediaDefaultMedia ? blockHalfTextMediaDefaultMedia.querySelector('video') : null;
        const blockHalfTextMediaAlternateVideo = blockHalfTextMediaAlternateMedia ? blockHalfTextMediaAlternateMedia.querySelector('video') : null;
        const blockHalfTextMediaItemsOut = [blockHalfTextMediaDefault, blockHalfTextMediaDefaultMedia].filter(Boolean);
        const blockHalfTextMediaItemsIn = [blockHalfTextMediaAlternate, blockHalfTextMediaAlternateMedia].filter(Boolean);

        blockHalfTextMedia.classList.add('block-half-text-media--alternate-revealed');

        if (blockHalfTextMediaDefaultVideo) {
            blockHalfTextMediaDefaultVideo.pause();
        }

        const showBlockHalfTextMediaAlternate = function () {
            blockHalfTextMediaItemsOut.forEach(function (blockHalfTextMediaItem) {
                blockHalfTextMediaItem.hidden = true;
                blockHalfTextMediaItem.classList.remove('is-active');
            });

            blockHalfTextMediaItemsIn.forEach(function (blockHalfTextMediaItem) {
                blockHalfTextMediaItem.hidden = false;
                blockHalfTextMediaItem.classList.add('is-active');
            });

            if (blockHalfTextMediaAlternateVideo) {
                blockHalfTextMediaAlternateVideo.play().catch(function () {});
            }

            if (typeof ScrollTrigger !== 'undefined') {
                ScrollTrigger.refresh();
            }
        };

        if (typeof gsap === 'undefined') {
            showBlockHalfTextMediaAlternate();
            return;
        }

        gsap.set(blockHalfTextMediaItemsIn, { autoAlpha: 0 });

        gsap.timeline()
            .to(blockHalfTextMediaItemsOut, {
                autoAlpha: 0,
                duration: 0.25,
                ease: 'power2.out',
            })
            .call(showBlockHalfTextMediaAlternate)
            .to(blockHalfTextMediaItemsIn, {
                autoAlpha: 1,
                duration: 0.35,
                ease: 'power2.out',
            });
    };

    blockHalfTextMediaOpenButton.addEventListener('click', blockHalfTextMediaReveal);
}

function setupBlockHalfTextMediaFullscreen(blockHalfTextMedia) {
    const blockHalfTextMediaOpenButtons = blockHalfTextMedia.querySelectorAll('[data-half-text-media-fullscreen-open], [data-half-text-media-popup-open]');
    const blockHalfTextMediaModals = blockHalfTextMedia.querySelectorAll('[data-half-text-media-fullscreen]');
    const blockHalfTextMediaPopupTrigger = blockHalfTextMedia.getAttribute('data-half-text-media-popup-trigger');

    if (blockHalfTextMediaOpenButtons.length === 0 && !blockHalfTextMediaPopupTrigger) return;
    if (blockHalfTextMediaModals.length === 0) return;

    let blockHalfTextMediaActiveOpenButton = null;

    const closeBlockHalfTextMediaModal = function (blockHalfTextMediaModal) {
        const blockHalfTextMediaModalVideo = blockHalfTextMediaModal.querySelector('video');
        const blockHalfTextMediaModalIframes = blockHalfTextMediaModal.querySelectorAll('iframe');

        blockHalfTextMedia.classList.remove('block-half-text-media--fullscreen-open');
        blockHalfTextMediaModal.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('has-modal-open');

        if (blockHalfTextMediaActiveOpenButton) {
            blockHalfTextMediaActiveOpenButton.setAttribute('aria-expanded', 'false');
        }

        if (blockHalfTextMediaModalVideo) {
            blockHalfTextMediaModalVideo.pause();
        }

        blockHalfTextMediaModalIframes.forEach(function (blockHalfTextMediaModalIframe) {
            blockHalfTextMediaModalIframe.src = blockHalfTextMediaModalIframe.src;
        });

        if (blockHalfTextMediaActiveOpenButton) {
            blockHalfTextMediaActiveOpenButton.focus();
        }

        blockHalfTextMediaActiveOpenButton = null;
    };

    const openBlockHalfTextMediaModal = function (blockHalfTextMediaModal, blockHalfTextMediaOpenButton) {
        const blockHalfTextMediaModalVideo = blockHalfTextMediaModal.querySelector('video');

        blockHalfTextMedia.classList.add('block-half-text-media--fullscreen-open');
        blockHalfTextMediaModal.setAttribute('aria-hidden', 'false');
        blockHalfTextMediaOpenButton.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('has-modal-open');
        blockHalfTextMediaActiveOpenButton = blockHalfTextMediaOpenButton;

        if (blockHalfTextMediaModalVideo) {
            blockHalfTextMediaModalVideo.play().catch(function () {});
        }

        const blockHalfTextMediaCloseButton = blockHalfTextMediaModal.querySelector('.block-half-text-media__fullscreen-close');
        if (blockHalfTextMediaCloseButton) {
            blockHalfTextMediaCloseButton.focus();
        }
    };

    const setupBlockHalfTextMediaOpenButton = function (blockHalfTextMediaOpenButton) {
        if (blockHalfTextMediaOpenButton.dataset.halfTextMediaPopupReady === 'true') return;

        blockHalfTextMediaOpenButton.dataset.halfTextMediaPopupReady = 'true';

        blockHalfTextMediaOpenButton.addEventListener('click', function (event) {
            event.preventDefault();

            const blockHalfTextMediaModalID = blockHalfTextMediaOpenButton.getAttribute('aria-controls');
            const blockHalfTextMediaModal = blockHalfTextMediaModalID ? document.getElementById(blockHalfTextMediaModalID) : blockHalfTextMediaModals[0];

            if (!blockHalfTextMediaModal) return;

            openBlockHalfTextMediaModal(blockHalfTextMediaModal, blockHalfTextMediaOpenButton);
        });
    };

    blockHalfTextMediaOpenButtons.forEach(setupBlockHalfTextMediaOpenButton);

    if (blockHalfTextMediaPopupTrigger) {
        blockHalfTextMedia.querySelectorAll('a[href]').forEach(function (blockHalfTextMediaLink) {
            const blockHalfTextMediaHref = blockHalfTextMediaLink.getAttribute('href');
            const blockHalfTextMediaUrl = new URL(blockHalfTextMediaLink.href, window.location.href);

            if (blockHalfTextMediaHref !== blockHalfTextMediaPopupTrigger && blockHalfTextMediaUrl.hash !== blockHalfTextMediaPopupTrigger) return;

            const blockHalfTextMediaPopupModal = blockHalfTextMedia.querySelector('[data-half-text-media-popup]');
            if (!blockHalfTextMediaPopupModal) return;

            blockHalfTextMediaLink.setAttribute('aria-controls', blockHalfTextMediaPopupModal.id);
            blockHalfTextMediaLink.setAttribute('aria-expanded', 'false');

            setupBlockHalfTextMediaOpenButton(blockHalfTextMediaLink);
        });
    }

    blockHalfTextMediaModals.forEach(function (blockHalfTextMediaModal) {
        const blockHalfTextMediaCloseButtons = blockHalfTextMediaModal.querySelectorAll('[data-half-text-media-fullscreen-close]');

        blockHalfTextMediaCloseButtons.forEach(function (blockHalfTextMediaCloseButton) {
            blockHalfTextMediaCloseButton.addEventListener('click', function () {
                closeBlockHalfTextMediaModal(blockHalfTextMediaModal);
            });
        });
    });

    document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape' || !blockHalfTextMedia.classList.contains('block-half-text-media--fullscreen-open')) return;

        const blockHalfTextMediaOpenModal = blockHalfTextMedia.querySelector('[data-half-text-media-fullscreen][aria-hidden="false"]');

        if (blockHalfTextMediaOpenModal) {
            closeBlockHalfTextMediaModal(blockHalfTextMediaOpenModal);
        }
    });
}
